export function isStrictlyNumeric(value: string | number) {
    const toCheck = typeof value === 'string' ? value.trim() : value;

    if (toCheck === '' || toCheck === null || typeof toCheck === 'boolean') {
        return false;
    }

    return !isNaN(Number(toCheck));
}
